import axios from "./axios";

export const convertPointCloud = async (projectId, outputFormat) => {
  return await axios.post(`/project/${projectId}/point-cloud/conversion`, {
    outputFormat,
  });
};

export const getConvertPointCloudProgress = async (projectId, jobId) => {
  return await axios.get(
    `/project/${projectId}/point-cloud/conversion/${jobId}/progress`
  );
};

export const getConvertPointCloudResult = async (projectId, jobId, config) => {
  return await axios.get(
    `/project/${projectId}/point-cloud/conversion/${jobId}/result`,
    { responseType: "blob", ...config }
  );
};

export const cancelConvertPointCloud = async (projectId, jobId) => {
  return await axios.delete(
    `/project/${projectId}/point-cloud/conversion/${jobId}`
  );
};
